import React from "react";
import { useQuery } from "@apollo/client";
import { CURRENT_USER } from "../api/queries/currentUser";
import { useTranslation } from "react-i18next";

export const Profile = () => {
  const { t } = useTranslation();
  return (
    <main role="main">
      <div>
        <h1>{t("profile.title")}</h1>
        <DisplayUser />
      </div>
    </main>
  );
};

function DisplayUser() {
  const { data, loading, error } = useQuery(CURRENT_USER);
  const { t } = useTranslation();

  if (loading) return <p>{t("global.loading")}</p>;
  if (error) return <p>{t("error.error", { error: error.message })}</p>;
  return (
    <div className="border">
      <img
        src={data?.me?.profilePhoto?.url || undefined}
        alt={data?.me?.name || t("profile.profilePhoto")}
      />
      <div>{t("profile.name", { name: data?.me?.name })}</div>
    </div>
  );
}
